import {gql} from 'apollo-angular';
import {StatusFragment} from "./fragments/Status";
// TODO: create fragment for all school class fields
export const GET_SCHOOL_CLASS_LOGIN = gql`
  query GetSchoolClassLogin($code: String!) {
    schoolClassLogin(classCode: $code) {
      status {
        ...statusFields
      }
      clientId
      school {
        id
        name
      }
      schoolClass {
        id
        name
        classNumber
        classAddition
        grade {
          id
          name
        }
      }
    }
  }
  ${StatusFragment}
`;
